import axios from 'axios';
import BaseUrl from '../util/BaseUrl';

// Base API URL
const API_URL = BaseUrl.baseUrl + 'users';

// Function to get token from localStorage
const getToken = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    return user ? user.token : null;
};

// Function to handle errors
const handleError = (error) => {
    throw new Error(error.response ? error.response.data.message : 'An error occurred');
};

// Get current logged-in user details
const getLogInUser = async () => {
    const token = getToken();
    try {
        const response = await axios.get(`${API_URL}/me`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

// Create a new user
const createUser = async (userDTO) => {
    const token = getToken();
    try {
        const response = await axios.post(API_URL, userDTO, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

// Get a user by ID
const getUserById = async (id) => {
    const token = getToken();
    try {
        const response = await axios.get(`${API_URL}/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

// Get all users with pagination
const getAllUsers = async (page = 0, size = 10) => {
    const token = getToken();
    try {
        const response = await axios.get(`${API_URL}?page=${page}&size=${size}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

// Update a user by ID
const updateUser = async (id, userDTO) => {
    const token = getToken();
    try {
        const response = await axios.put(`${API_URL}/${id}`, userDTO, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

// Delete a user by ID
const deleteUser = async (id) => {
    const token = getToken();
    try {
        await axios.delete(`${API_URL}/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    } catch (error) {
        handleError(error);
    }
};

// Upload a profile picture for a user
const uploadImage = async (id, formData) => {
    const token = getToken();
    // const formData = new FormData();
    // formData.append('image', imageFile);

    try {
        await axios.post(`${API_URL}/${id}/upload-image`, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
    } catch (error) {
        handleError(error);
    }
};

// Remove a profile picture for a user
const removeImage = async (id) => {
    const token = getToken();
    try {
        await axios.delete(`${API_URL}/${id}/remove-image`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    } catch (error) {
        handleError(error);
    }
};

// Activate a user
const activateUser = async (id) => {
    const token = getToken();
    try {
        await axios.patch(`${API_URL}/${id}/activate`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    } catch (error) {
        handleError(error);
    }
};

// Deactivate a user
const deactivateUser = async (id) => {
    const token = getToken();
    try {
        await axios.patch(`${API_URL}/${id}/deactivate`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    } catch (error) {
        handleError(error);
    }
};

// Update password
const updatePassword = async (id, updatePasswordRequest) => {
    const token = getToken();
    try {
        await axios.patch(`${API_URL}/${id}/update-password`, updatePasswordRequest, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    } catch (error) {
        handleError(error);
    }
};

// Export all methods as UserService
const UserService = {
    getLogInUser,
    createUser,
    getUserById,
    getAllUsers,
    updateUser,
    deleteUser,
    uploadImage,
    removeImage,
    activateUser,
    deactivateUser,
    updatePassword,
};

export default UserService;
